import { Logger } from "@lululemon/mwa-logger";

export const productEducationLogger = new Logger({
  owner: "product-ed",
  app: "product-ed-app"
});

export const productEdHandleError = (
  error,
  componentName,
  featureName,
  functionName = " "
) => {
  productEducationLogger.error(
    error,
    {
      tags: {
        componentName: componentName,
        featureName: featureName,
        functionName: functionName
      },
      fingerprint: [error.message, featureName]
    },
    (scope) => {
      scope.setContext("Error Object", error);
    }
  );
};
